import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import clsx from 'clsx';

import type { SubHeadingLevel } from './AnalysisSubHeader';

interface SubSectionLabelProps {
  icon: LucideIcon;
  /**
   * Tailwind text-color class for the icon. Sections that colour-code a block still pass
   * one; left off, the icon takes the label's own colour, which is what the design asks for.
   */
  iconClassName?: string;
  /**
   * Heading level for the label. `h2` for a sub-section directly under the section
   * heading; `h3` where it sits inside an already-titled block.
   */
  headingLevel?: SubHeadingLevel;
  children: ReactNode;
}

/** Small muted label above a block of body copy, led by its icon. */
export const SubSectionLabel = ({
  icon: Icon,
  iconClassName,
  headingLevel: Heading = 'h2',
  children,
}: SubSectionLabelProps) => (
  <Heading className="flex items-center gap-2 text-label-md font-medium text-foreground-subtle">
    <Icon className={clsx('size-4 shrink-0', iconClassName)} />
    {children}
  </Heading>
);
